import { memo } from 'react';
import { Dropdown, Table } from 'semantic-ui-react';
import { StandardizedLabelType } from '../../../../../../../schemas/standardizedLabel.schemas';
import { serverToLocalDate } from '../../../../../../../utils/dateTimeUtils';

type StandardizedLabelRowProps = {
    standardizedLabel: StandardizedLabelType;
    onEdit: (a: StandardizedLabelType) => void;
    onDelete: (a: StandardizedLabelType) => void;
};

const StandardizedLabelRow = memo(({ standardizedLabel, onEdit, onDelete }: StandardizedLabelRowProps) => {
    const options = [
        { key: 'delete', text: 'Delete', value: 'delete', onClick: () => onDelete(standardizedLabel) },
        { key: 'edit', text: 'Edit', value: 'edit', onClick: () => onEdit(standardizedLabel) },
    ];

    return (
        <Table.Row>
            <Table.Cell collapsing className="noPadding">
                <Dropdown icon="ellipsis vertical" options={options} trigger={<></>} />
            </Table.Cell>
            <Table.Cell>{standardizedLabel.id}</Table.Cell>
            <Table.Cell>{standardizedLabel.name}</Table.Cell>
            <Table.Cell>{standardizedLabel.scope}</Table.Cell>
            <Table.Cell>{serverToLocalDate(standardizedLabel.createdOn)}</Table.Cell>
            <Table.Cell>{serverToLocalDate(standardizedLabel.updatedOn)}</Table.Cell>
        </Table.Row>
    );
});

export default StandardizedLabelRow;
